import React from "react";
import Cart from "./FoodApp/Cart/Cart";
import Header from "./FoodApp/Layouts/Header";
import Meals from "./FoodApp/Meals/Meals";
import { useState } from "react";
import CartProvider from "./store/CartProvider";

const App = () => {
  const [cartIsShown, setCartIsShown] = useState(false);

  const showCartHandler = () => {
    setCartIsShown(true);
  };
  const hideCartHandler = () => {
    setCartIsShown(false);
  };
  return (
    <CartProvider>
      {/* <Demo/> */}
      {cartIsShown && <Cart onClose={hideCartHandler} />}
      <Header onShowCart={showCartHandler} />
      <main>
        <Meals />
      </main>
    </CartProvider>

  );
};

export default App;
